/**
 * Reason a rate-limit request was denied.
 *
 * Used by `IAiRateLimiterService.consume()` to indicate which of the layered
 * counters (session cookie or IP ceiling) caused the denial. Session-limit is
 * considered the "primary" reason presented to end users.
 */
export enum AiRateLimitDeniedReasonEnum {
  SessionLimit = 'session-limit',
  IpCeiling = 'ip-ceiling',
}
